import axios from "axios";
import { CallConfirmDialog, glbGetLocalStorage, glbSetLocalStorage, mobileCheck } from "./Helpers/GlobalFunctions";
import { APIBaseURL, GatewayURL } from "./apiConnect/config";
import { v1 as uuidv1 } from 'uuid';
export function subscribe(psapplicationServerKey, refSubscriptionElement) {
    try {
        if ('serviceWorker' in navigator && 'PushManager' in window) {
            navigator.serviceWorker.ready.then((registration) => {
                registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: psapplicationServerKey,
                }).then((subscription) => {
                    console.log(subscription);
                    let ep = subscription.endpoint;
                    let pd = arrayBufferToBase64(subscription.getKey("p256dh"));
                    let auth = arrayBufferToBase64(subscription.getKey("auth"));
                    let loparamconfig = fnlGetParamConfiguration();
                    let lsapirul = loparamconfig.apiurl;

                    let lsUserData = glbGetLocalStorage("ssUserData");
                    let bodyJson = loparamconfig.body;
                    bodyJson.endpoint = ep;
                    bodyJson.pdh = pd;
                    bodyJson.auth = auth;
                    bodyJson.tcd = lsUserData.tcd;
                    bodyJson.ccd = "0";

                    let loHeader = {
                        "Content-Type": "application/json"
                    };

                    lsapirul = lsapirul + "api/v1/notification/subscribe";
                    axios.post(lsapirul, JSON.stringify(bodyJson), { headers: loHeader }, { timeout: 900 }).then((response) => {
                        if (response.status == 200 || response.data == true) {
                            fnlSubscribeUnsubscribe(refSubscriptionElement, 'subscribe');
                            CallConfirmDialog("success", "Push Notification Subscribed Successfully");
                        }
                    }).catch((error) => {
                        console.log(error);
                        // console.log("Join Check Status Failed " + err.toString());
                        let lserror = error;
                        if (typeof lserror === "object" && lserror !== null && error.response !== undefined) {
                            lserror = error.response.data.title;
                        }
                        CallConfirmDialog("error", "Error subscribing to push notifications:" + lserror);
                        console.error('Error subscribing to push notifications:', error);
                    }
                    );
                }).catch((error) => {
                    console.log(error);
                    let lserror = error;
                    if (typeof lserror === "object" && lserror !== null && error.response !== undefined) {
                        lserror = error.response.data.title;
                    }
                    CallConfirmDialog("info", "Error subscribing to push notifications:" + lserror);
                    console.error('Error subscribing to push notifications:', error);
                });
            });
        }
        function arrayBufferToBase64(buffer) {
            var binary = '';
            var bytes = new Uint8Array(buffer);
            var len = bytes.byteLength;
            for (var i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        }
    }
    catch (err) {
        console.log(err);
    }
}
export function unsubscribe(psapplicationServerKey, refSubscriptionElement) {
    let loparamconfig = fnlGetParamConfiguration();
    let lsapirul = loparamconfig.apiurl;
    let bodyJson = loparamconfig.body;
    let lsAccessToken = glbGetLocalStorage("accesstoken");
    let loHeader = {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + lsAccessToken
    };
    lsapirul = lsapirul + "api/v1/notification/unsubscribe";
    /*gateway api end*/
    axios.post(lsapirul, JSON.stringify(bodyJson), { headers: loHeader }, { timeout: 900 }).then((response) => {
        if (response.status == 200 || response.data == true) {
            fnlSubscribeUnsubscribe(refSubscriptionElement, 'unsubscribe');
            CallConfirmDialog("success", "Push Notification Unsubscribed Successfully");
        }
    }).catch((error) => {
        // console.log("Join Check Status Failed " + err.toString());
        let lserror = error;
        if (typeof lserror === "object" && lserror !== null && error.response !== undefined) {
            lserror = error.response.data.title;
        }
        CallConfirmDialog("info", "Error Unsubscribing to push notifications:" + lserror);
        console.error('Error unsubscribing to push notifications:', lserror);
    }
    );
}
export async function checksubscribe(psapplicationserverkey, refSubscriptionElement, pstype) {
    let lbbrowsersubscribed = false;
    if ('permissions' in navigator) {
        navigator.permissions.query({ name: 'notifications' }).then(function (notificationPerm) {
            if (notificationPerm.state === "granted") {
                lbbrowsersubscribed = true;
            }
            fnlCheckApplicationSubscription(lbbrowsersubscribed, refSubscriptionElement);
            notificationPerm.onchange = function () {
                console.log("User decided to change his seettings. New permission: " + notificationPerm.state);
                if (notificationPerm.state === "denied") {
                    unsubscribe("", refSubscriptionElement);
                }
            };
        });
    }
}
function fnlCheckApplicationSubscription(pbbrowsersubscribed, refSubscriptionElement) {
    let loparamconfig = fnlGetParamConfiguration();
    let lsapirul = loparamconfig.apiurl;
    let bodyJson = loparamconfig.body;
    let lsAccessToken = glbGetLocalStorage("accesstoken");
    let loHeader = {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + lsAccessToken
    };
    lsapirul = lsapirul + "api/v1/notification/checksubscription";
    axios.post(lsapirul, JSON.stringify(bodyJson), { headers: loHeader }, { timeout: 900 }).then((response) => {
        if (response.status == 200) {
            if (response.data == true) {
                if (pbbrowsersubscribed === true) {
                    fnlSubscribeUnsubscribe(refSubscriptionElement, 'subscribe');
                }
                else {
                    fnlSubscribeUnsubscribe(refSubscriptionElement, 'unsubscribe');
                }
            }
            else {
                fnlSubscribeUnsubscribe(refSubscriptionElement, 'unsubscribe');
            }
        }
    }).catch((err) => {
        // console.log("Join Check Status Failed " + err.toString());
        // CallConfirmDialog("info", "Error Check subscribing to push notifications:" + err.response.data.title);
        console.error('Error Check subscribing to push notifications:', err);
    }
    );
}
function fnlSubscribeUnsubscribe(refSubscriptionElement, pstype) {
    glbSetLocalStorage("subscriptiontype", pstype);
    if (pstype === "subscribe") {
        refSubscriptionElement.current.setAttribute("title", 'Unsubscribe Notification');
        refSubscriptionElement.current.querySelector("#subscription_content").innerText = 'Unsubscribe Notification';
        refSubscriptionElement.current.querySelector("#subscription_icon").classList.add("fa-bell-slash");
        refSubscriptionElement.current.querySelector("#subscription_icon").classList.remove("fa-bell");
        refSubscriptionElement.current.classList.add("d-none");
    }
    else {
        refSubscriptionElement.current.setAttribute("title", 'Subscribe Notification');
        refSubscriptionElement.current.querySelector("#subscription_content").innerText = 'Subscribe Notification';
        refSubscriptionElement.current.querySelector("#subscription_icon").classList.remove("fa-bell-slash");
        refSubscriptionElement.current.querySelector("#subscription_icon").classList.add("fa-bell");
        refSubscriptionElement.current.classList.remove("d-none");
    }
}
function fnlGetParamConfiguration() {
    /*local api start*/
    /*let lsAPIBaseURL = APIBaseURL;
    try {
        if (window.origin.includes("localhost:44466") === false && process.env.PUBLIC_URL !== undefined && process.env.PUBLIC_URL !== "" && process.env.PUBLIC_URL !== null) {
            lsAPIBaseURL = window.origin + "/" + process.env.PUBLIC_URL + '/api/';
            console.log(lsAPIBaseURL);
        }
    }
    catch (err) {
        console.log(err, "PUBLIC_URL error");
    }*/
    /*local api end*/
    /*gateway api start*/
    let lsGatewayURL = GatewayURL;
    let loconfig = glbGetLocalStorage("config");
    if (loconfig !== undefined && loconfig !== null) {
        if (loconfig.hasOwnProperty("notificationurl")) {
            lsGatewayURL = loconfig.notificationurl;
        }
    }
    let lshostname = glbGetLocalStorage("uniqueid");
    if (!(lshostname !== undefined && lshostname !== null && lshostname !== "")) {
        lshostname = uuidv1();
        glbSetLocalStorage("uniqueid", lshostname);
    }
    let lossUserData = glbGetLocalStorage("ssUserData");
    let loUserconfig = glbGetLocalStorage("ssUserConfig");
    let lorefinfo = {};
    if (loUserconfig !== undefined && loUserconfig !== null && loUserconfig !== "") {
        lorefinfo = loUserconfig.defvalues;
    }
    let apprights = lossUserData.apprights;
    let groupname = [];
    if (apprights != undefined && apprights.length > 0) {
        apprights.map((role) => {
            if (groupname.indexOf(role.project + ":" + role.roles) == -1) {
                groupname.push(role.project + ":" + role.roles);
            }
        })
    }
    groupname = groupname.join(",");
    let dvctype = "w";
    let lbismobile = mobileCheck();
    if (lbismobile === true) {
        dvctype = "m";
    }
    let bodyJson = {
        "orgid": lorefinfo.orgid.toString(),
        "usercode": lossUserData.usercode,
        "env": lorefinfo.envtype,
        "dvctype": dvctype,
        "dvcid": lshostname,
        "group": groupname
    }
    let lojson = {
        body: bodyJson,
        apiurl: lsGatewayURL
    }
    return lojson;
}
//old methods for reference
export async function checksubscribeold(psapplicationserverkey, refSubscriptionElement, pstype) {
    await navigator.serviceWorker.ready.then((registration) => {
        registration.pushManager.getSubscription().then(async (subscription) => {
            if (subscription === null) {
                if (pstype !== "check") {
                    subscribe(psapplicationserverkey, refSubscriptionElement);
                    // fnlSubscribeUnsubscribe(refSubscriptionElement, "subscribe");
                }
                else {
                    fnlSubscribeUnsubscribe(refSubscriptionElement, "unsubscribe");
                }
            }
            else {

                if (pstype !== "check") {
                    unsubscribe('', refSubscriptionElement);
                    // fnlSubscribeUnsubscribe(refSubscriptionElement, "unsubscribe");
                }
                else {
                    fnlSubscribeUnsubscribe(refSubscriptionElement, "subscribe");
                }
            }
            return subscription;
        });
    });
}
export function unsubscribeold() {
    navigator.serviceWorker.ready.then((registration) => {
        registration.pushManager.getSubscription().then((subscription) => {
            subscription
                .unsubscribe()
                .then((successful) => {
                    console.log("You've successfully unsubscribed");
                    CallConfirmDialog("success", "Push Notification Unsubscribed Successfully");
                    return true;
                })
                .catch((e) => {
                    // Unsubscribing failed
                });
        });
    });
}